import React from "react";
import "../assets/styles/products.css";
import ser1 from "../assets/images/ser1.svg";
import ser2 from "../assets/images/ser2.svg";
import j1 from "../assets/images/j1.png";
import j2 from "../assets/images/j2.png";
import j3 from "../assets/images/j3.png";
import j4 from "../assets/images/j4.png";
import j5 from "../assets/images/j5.png";
import k from "../assets/images/k111.png";
import k1 from "../assets/images/Play.png";
import k11 from "../assets/images/app.png";
import Syncturma from "../assets/images/syncturma.png";
import Marquee from "react-fast-marquee";

const Products = () => {

  const clientLogos = [
    <a key="j1" href="https://syncturma.com/" target="_blank" rel="noopener noreferrer">
      <img src={Syncturma} alt="Client 1 Logo" className="product-logo" />
    </a>,
    <a key="j3" href="https://commceed.com/" target="_blank" rel="noopener noreferrer">
      <img src={j3} alt="Client 3 Logo" className="product-logo" />
    </a>,
    <div key="k-group" className="image-row" style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      <img src={k} alt="Client Logo" style={{ width: "80px", objectFit: "contain" }} />
      <div className="vertical-stack" style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div style={{ border: "1px solid white", borderRadius: "5px" }}>
          <a href="https://play.google.com/store/apps/details?id=com.syncrones.dewawandanadahara" target="_blank" rel="noopener noreferrer">
            <img src={k1} alt="Play Store" style={{ width: "80px", objectFit: "contain" }} />
          </a>
        </div>
        <div style={{ border: "1px solid white", borderRadius: "5px" }}>
          <a href="https://apps.apple.com/us/app/deva-wandana-dahara/id6743715416?platform=iphone" target="_blank" rel="noopener noreferrer">
            <img src={k11} alt="App Store" style={{ width: "80px", objectFit: "contain" }} />
          </a>
        </div>
      </div>
    </div>,
    <a key="j4" href="https://site4.com" target="_blank" rel="noopener noreferrer">
      <img src={j4} alt="Client 4 Logo" className="product-logo" />
    </a>,
    <a key="j5" href="https://homefactor.co.nz/" target="_blank" rel="noopener noreferrer">
      <img src={j5} alt="Client 5 Logo" className="product-logo" />
    </a>
  ];

  // Duplicate the array to create seamless loop
  const duplicatedLogos = [...clientLogos, ...clientLogos, ...clientLogos];

  return (
    <section className="products-section">
      <div className="products-header">
        <div className="blur-circle right"></div>
        <h2 className="services-title">
          <div className="line-container">
            <img src={ser1} alt="Line 1" className="line" />
            <img src={ser2} alt="Line 2" className="line" />
            Our Clients
          </div>
        </h2>
        <p className="products-description">
          Explore our portfolio of innovative products powered by AI and modern
          technology.
        </p>
      </div>

      <div className="products-slider">
        <div className="blur-circle right"></div>
        <div className="products-track">

        <Marquee
        speed={50}
        pauseOnHover={false}
        gradient={false}
        className="products-marquee"
      >
        <div className="products-content">
          {duplicatedLogos.map((logo, index) => (
            <div key={index} style={{ margin: "0 2rem" }}>
              {logo}
            </div>
          ))}
        </div>
      </Marquee>
          {/* <div
            className="products-box"
            style={{ display: "flex", gap: "120px" }}
          >
            <a
              href="https://syncturma.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={j1} alt="Client 1 Logo" />
            </a>
            <div
              className="image-row"
              style={{ display: "flex", alignItems: "center", gap: "1rem" }}
            >
              <img
                src={k}
                alt="Client 1 Logo"
                style={{ width: "80px", objectFit: "contain" }}
              />

              <div
                className="vertical-stack"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <div
                style={{
                  border: "1px solid white",
                  borderRadius: "5px",
                }}>
                <a
                  href="https://play.google.com/store/apps/details?id=com.syncrones.dewawandanadahara"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={k1}
                    alt="Client 2 Logo"
                    style={{ width: "80px", objectFit: "contain" }}
                  />
                </a>
                </div>
                <div
                style={{
                  border: "1px solid white",
                  borderRadius: "5px",
                }}>
                <a
                  href="https://apps.apple.com/us/app/deva-wandana-dahara/id6743715416?platform=iphone"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={k11}
                    alt="Client 3 Logo"
                    style={{ width: "80px", objectFit: "contain" }}
                  />
                </a>
                </div>
              </div>
            </div>

            <a
              href="https://commceed.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={j3} alt="Client 3 Logo" />
            </a>
            <a
              href="https://site4.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={j4} alt="Client 4 Logo" />
            </a>
            <a
              href="https://homefactor.co.nz/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={j5} alt="Client 5 Logo" />
            </a>
          </div> */}

          

          <div className="blur-circle right"></div>
      
        </div>
      </div>
    </section>
  );
};

export default Products;
